//IMPORT HEADER
import tomillo_header from "./components/header";
//IMPORT FOOTER
import tomillo_footer from "./components/footer";
//EASING JS
import './assets/js/jquery.easing.min.js';
//TYPED JS
import './assets/js/typed.min.js';
//ENLLAX JS
import './assets/js/jquery.enllax.min.js';
//OWL CAROUSEL JS
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel';
//WOW JS
import { WOW } from 'wowjs';
//PARALLAX JS
import 'jquery-parallax.js/parallax.js';

export default {
    name: 'App',
    created() {
        document.title = "Tomillo | Multi Purpose Vue Js Landing Page";
    },
    components: {
        tomillo_header,
        tomillo_footer
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.hidePreloader();
            this.initTyping();
            this.initEnllax();
            this.initClientSlider();
            this.initWowAnimation();
            this.initParallax();
            this.initAccordian();
            this.windowScroll();
            this.initElementClick();
        },
        /*----ONSCROLL JS-----*/
        windowScroll() {
            var self = this;
            $(window).on("scroll", function () {
                self.initCounter();
                self.initSectionScroll();                
            });
        },
        /*----PRELOADER-----*/
        hidePreloader() {
            var preloaderFadeOutTime = 500;
            var preloader = $('.spinner-wrapper');
            setTimeout(function () {
                preloader.fadeOut(preloaderFadeOutTime);
            }, 500);
        },
        /*----PARALLAX IMAGE-----*/
        initParallax() {
            var length = $('.parallax-box').length;
            if (length >= 1) {
                $('.parallax-box').parallax({ imageSrc: './assets/images/parallax.jpg' });
            }
        },
        /*----WOW ANIMATION-----*/
        initWowAnimation() {
            var length = $('.wow').length;
            if (length >= 1) {
                const wow = new WOW({
                    boxClass: 'wow',
                    animateClass: 'animated',
                    offset: 0,
                });
                wow.init();
            }
        },
        /*----Element Clicks -----*/
        initElementClick() {
            /*----Menu CLose Click -----*/
            $(".menu-close-btn").on("click", function () {
                $('.navbar-collapse').removeClass('show');
            }),
                /*----Menu Links Click -----*/
                $(".custom-nav .nav-item a").on("click", function (o) {
                    var t = $(this);
                    $('.nav-item').removeClass('active');
                    $(t).parent().addClass('active');
                    $("html, body").stop().animate({
                        scrollTop: $(t.attr("href")).offset().top - 50
                    }, 1500, "easeInOutExpo"), o.preventDefault()
                }),
                /*----Mobile Menu Click -----*/
                $(document).on("click", ".navbar-collapse.show", function (o) {
                    $(o.target).is("a") && $(this).collapse("hide")
                }),
                /*----Back To Top Clicks -----*/
                $(".back_top").on("click", function () {
                    return $("html, body").animate({
                        scrollTop: 0
                    }, 1e3), !1
                });
            /*----Contact & Down Arrow Click -----*/
            $(".scroll-next, .header_btn a").on("click", function (event) {
                var t = $(this);
                $("html, body").stop().animate({
                    scrollTop: $(t.attr("href")).offset().top - 50
                }, 2000, "easeInOutExpo"), event.preventDefault()
            })
        },
        /*----Section Scroll -----*/
        initSectionScroll() {
            var sections = $('section'),
                nav = $('.navbar-nav'),
                nav_height = nav.outerHeight() + 25,
                win_scroll_top = $(window).scrollTop();
            win_scroll_top >= 80 ? $("nav").addClass("sticky-header") : $(".sticky").removeClass("sticky-header");
            win_scroll_top > 100 ? $(".back_top").fadeIn() : $(".back_top").fadeOut()
            /*----ON SCROLL CHANGE ACTIVE MENU-----*/
            var cur_pos = $(window).scrollTop();
            sections.each(function () {
                var top = $(this).offset().top - nav_height,
                    bottom = top + $(this).outerHeight();
                if (cur_pos >= top && cur_pos <= bottom) {
                    nav.find('li').removeClass('active');
                    $(this).addClass('active');
                    nav.find('a[href="#' + $(this).attr('id') + '"]').parent().addClass('active');
                }
            });
        },
        /*----ENLLAX SCROLLING-----*/
        initEnllax() {
            $('.scroll-title').enllax();
        },
        /*----ACCORDIAN-----*/
        initAccordian() {
            $(".question-card").on('click', function () {
                if ($(this).hasClass('active')) {
                    $('.question-card').removeClass('active');
                    $(this).removeClass('active')
                } else {
                    $('.question-card').removeClass('active');
                    $(this).addClass('active')
                }
            });
        },
        /*----COUNTER-----*/
        initCounter() {
            var a = 0;
            var oTop = $('#counter').offset().top - window.innerHeight;
            if (a == 0 && $(window).scrollTop() > oTop) {
                $('.counter-value').each(function () {
                    var $this = $(this),
                        countTo = $this.attr('data-count');
                    $({
                        countNum: $this.text()
                    }).animate({
                        countNum: countTo
                    }, {
                            duration: 2000,
                            easing: 'swing',
                            step: function () {
                                $this.text(Math.floor(this.countNum));
                            },
                            complete: function () {
                                $this.text(this.countNum);
                            }
                        });
                });
                a = 1;
            }
        },
        /*----TESTIMONIAL SLIDER-----*/
        initClientSlider() {
            var testimonialCarousel = $('.client-slider');
            if (testimonialCarousel.length > 0) {
                testimonialCarousel.owlCarousel({
                    margin: 0,
                    loop: false,
                    nav: true,
                    center: false,
                    dots: false,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    items: 3,
                    responsiveClass: true,
                    navText: ['<span class="mdi mdi-arrow-left"></span>', '<span class="mdi mdi-arrow-right"></span>'],
                    responsive: {
                        0: {
                            items: 1,
                        },
                        600: {
                            items: 2,
                        },
                        1000: {
                            items: 2,
                        }
                    }
                });
            }
        },
        /*----TYPED JS-----*/
        initTyping() {
            $(".typed").typed({
                strings: ["Improve your Business."],
                stringsElement: null,
                typeSpeed: 30,
                startDelay: 1200,
                backSpeed: 20,
                backDelay: 500,
                loop: true,
                loopCount: 5,
                showCursor: false,
                cursorChar: "|",
                attr: null,
                contentType: 'html',
                callback: function () { },
                preStringTyped: function () { },
                onStringTyped: function () { },
                resetCallback: function () { }
            });
        }
    }
}